import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewEncapsulation,
} from '@angular/core';
import { MenuItem, PrimeNGConfig } from 'primeng/api';
import { HeaderService } from './header.service';

@Component({
  selector: 'lh-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
})
export class HeaderComponent implements OnInit {
  @Output() readonly logout: EventEmitter<void> = new EventEmitter<void>();
  @Input() userName: string | null = '';
  items: MenuItem[] = [];
  isUserMenuOpen: boolean = false;

  constructor(
    public readonly headerAnimationService: HeaderService,
    private readonly primengConfig: PrimeNGConfig,
  ) {}

  ngOnInit(): void {
    this.initUsernameMenu();
  }

  initUsernameMenu(): void {
    this.primengConfig.zIndex = {
      modal: 0,
      overlay: 0,
      menu: 0,
    };
    this.items = [
      {
        id: 'sign-out',
        styleClass: 'sign-out-link',
        label: `
          <div class="logout-item">
            <i class="fa-solid fa-arrow-right-from-bracket"></i>
            <span class="logout-item__label">Sign Out</span>
          </div>
        `,
        escape: false,
        command: (): void => this.signOut(),
      },
    ];
  }

  toggleUserMenu(close?: boolean): void {
    this.isUserMenuOpen = close ?? !this.isUserMenuOpen;
  }

  signOut(): void {
    this.logout.emit();
  }
}
